<template>
	<div v-if="isVisible" class="px-4 formField">
		<v-menu
			:close-on-click="false"
			:close-on-content-click="false"
			:open-on-click="false"
			offset-y
			v-model="menuStatus"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-text-field
					:disabled="formField.Readonly"
					:rules="validationRules"
					@keyup="uppercase"
					:class="getUppercaseClass"
					clearable
					:tabindex="tabIndex"
					v-bind="attrs"
					v-on="on"
					:label="formField.Label"
					v-model="selectedValue"
					hide-details="auto"
					@click:clear="onClear"
					@focus="onFocus"
					@blur="onBlur"
				>
					<template v-slot:append>
						<v-icon v-if="menuStatus">mdi-menu-up</v-icon>
						<v-icon v-else class="rotate">mdi-menu-up</v-icon>
					</template>
					<template
						v-slot:prepend
						v-if="visibleBubble || visibleHelp"
					>
						<div v-if="visibleBubble">
							<v-tooltip
								top
								nudge-top="20"
								:open-on-click="true"
								:open-on-focus="true"
								:open-on-hover="true"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-icon
										color="primary"
										v-bind="attrs"
										v-on="on"
										:tabindex="tabIndex"
										>mdi-information-outline</v-icon
									>
								</template>
								{{ bubbleText }}
							</v-tooltip>
						</div>
						<div v-if="visibleHelp">
							<v-tooltip
								top
								nudge-top="20"
								:open-on-click="true"
								:open-on-focus="true"
								:open-on-hover="true"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-icon
										color="primary"
										v-bind="attrs"
										v-on="on"
										:tabindex="tabIndex"
										>mdi-help-circle-outline</v-icon
									>
								</template>
								{{ helpText }}
							</v-tooltip>
						</div>
					</template>
					<template v-slot:append-outer v-if="canRetainValue">
						<div>
							<v-icon v-if="!hasRetainedValue" @click="onPinClick"
								>mdi-pin-off-outline</v-icon
							>
							<v-icon
								v-else
								color="primary"
								class="rotate45"
								@click="onPinClick"
								>mdi-pin-outline</v-icon
							>
						</div>
					</template>
				</v-text-field>
			</template>
			<div v-if="menuStatus" style="background-color: white">
				<v-overlay absolute="absolute" :value="loading" :dark="false">
					<v-card max-width="200px">
						<v-card-text class="d-flex justify-center">
							<v-progress-circular
								:size="25"
								indeterminate
								color="primary"
							/>
							<span class="mx-3 text-button">Loading</span>
						</v-card-text>
					</v-card>
				</v-overlay>
				<v-list v-if="filteredValues">
					<v-list-item-group
						v-model="selected"
						active-class="primary white--text"
						class="field-list"
					>
						<v-list-item
							v-for="(item, index) in filteredValues"
							@mousedown="onSelectItem(item)"
							:key="index"
							:value="item"
						>
							<v-list-item-content>
								<v-list-item-title>
									{{ item.Value }}</v-list-item-title
								>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</div>
		</v-menu>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { InventoryFormGetters } from '../../../../store/getters';
import { InventoryFormActions } from '../../../../store/actions';
import formFieldMixin from '../../../../mixins/inventoryForm/formFieldMixin';
import dataFieldUtils from '../../../../utils/dataFieldUtils';
export default {
	name: 'ReferenceListField',
	mixins: [formFieldMixin],
	computed: {
		...mapGetters({
			referenceListValues: InventoryFormGetters.GET_REFERENCE_LIST_VALUES,
		}),
		gridViewField() {
			if (!this.formField) return null;
			return this.formField.GridViewFields[0];
		},

		dataFieldKey() {
			if (!this.gridViewField) return null;
			if (!this.gridViewField.DataField) return null;
			return dataFieldUtils.getDataFieldName(
				this.gridViewField.DataField
			);
		},

		referenceListTypeId() {
			if (!this.gridViewField) return null;
			return this.gridViewField.ReferenceListTypeId;
		},
		allValues() {
			if (!this.referenceListTypeId) return [];
			return this.allItems
				.filter((x) => x.TypeId == this.referenceListTypeId)
				.sort((a, b) => a.Order - b.Order);
		},

		filteredValues() {
			if (!this.selectedValue) return this.allValues;
			return this.allValues.filter(
				(x) =>
					x.Value &&
					x.Value.toLowerCase().includes(
						this.selectedValue.toLowerCase()
					)
			);
		},

		recordSelected() {
			if (!this.dataFieldKey) return null;
			if (!this.recordKeys[0]) return null;
			let selectedItem = {};
			selectedItem.Id = this.record[this.dataFieldKey];
			selectedItem.Value = this.record[this.recordKeys[0]];
			return selectedItem;
		},
	},

	data() {
		return {
			hasFocus: false,
			menuStatus: false,
			selected: null,
			allItems: [],
			loading: false,
		};
	},
	mounted() {
		this.defaultRules.push((v) => {
			if (this.formField.Required && !this.isBulkEdit) {
				if (!v) return false || 'The value is required';
				else return true;
			} else return true;
		});

		if (this.recordSelectedValue) {
			this.selectedValue = this.recordSelectedValue;
			this.selected = this.recordSelected;
		}
	},

	methods: {
		onRecordChanged() {
			if (
				this.recordSelectedValue &&
				this.selectedValue != this.recordSelectedValue
			) {
				this.selectedValue = this.recordSelectedValue;
				this.selected = this.recordSelected;
				return;
			}

			if (
				this.selectedValue &&
				this.selectedValue != this.recordSelectedValue
			) {
				this.selectedValue = null;
				this.selected = null;
			}
		},
		onHideFormField() {
			this.onSelectItem({ Id: null, Value: null });
		},

		onFocus() {
			this.hasFocus = true;
			this.menuStatus = true;
			if (this.allItems.length <= 0) {
				this.loading = true;
				this.$store
					.dispatch(InventoryFormActions.LOAD_REFERENCE_LIST_VALUES)
					.then((resp) => {
						this.allItems = resp;
						this.loading = false;
					});
			}
		},
		onBlur() {
			this.allItems = [];
			this.hasFocus = false;
			this.menuStatus = false;
			if (
				this.selectedValue != this.recordSelectedValue &&
				!this.selected
			) {
				this.updateRecord();
			}
		},

		onClear() {
			this.onSelectItem({ Id: null, Value: null });
			this.menuStatus = true;
		},
		onSelectItem(referenceListValue) {
			this.selected = referenceListValue;
			this.selectedValue = referenceListValue.Value;
			this.menuStatus = false;
			this.updateRecord();
		},

		updateRecord() {
			let keys = [];
			let item = { key: this.recordKeys[0], value: this.selectedValue };
			keys.push(item);
			let idValue = null;
			if (this.selectedValue) idValue = null;
			if (this.selected && this.selected.Id) idValue = this.selected.Id;
			keys.push({ key: this.dataFieldKey, value: idValue });

			this.skipNextRecordUpdate = true;
			this.$emit('selectedValueChanged', keys);
		},

		onSelectedValueChanged() {
			//does Nothing -> function is called from mixin; For this component we handle selected not selectedValue;selectedValue=search criteria;
			this.selected = null;
		},
	},
};
</script>

<style lang="scss">
.rotate {
	transform: rotate(180deg);
}
.v-menu__content {
	background-color: white;
}
</style>
